import { ApiResponseError } from "./ApiResponseError";
import { ConflictError } from "./ConflictError";
import { NoPermissionError } from "./NoPermissionError";
import { NoSessionError } from "./NoSessionError";
import { NotFoundError } from "./NotFoundError";
import { ServerSideError } from "./ServerSideError";
import { ServiceUnavailableError } from "./ServiceUnavailableError";
import { ValidationError } from "./ValidationError";
import axios from "./axios";

export type UuidType = {
    uuid?: string,
}

export type ScoregType = {
    uuid?: string,
    permissions?: string[],
}

export type ScoregCreateType = object

export interface ScoregActiveType {
    active: boolean,
}

export type ReferenceType = {
    uuid?: string,
}

export type SessionType = {
    accessKey: string
}

export type RevisionMetadataType = {
    revisionNumber: number,
    revisionInstant: Date,
    username: string,
    organization: string,
}

export type RevisionType<T> = {
    entity: T,
    metadata: RevisionMetadataType,
}

export async function fetchRecord<T>(path: string, uuid: string) {
    console.log(`Fetching ${path} with uuid ${uuid}...`)
    const detail = await axios
        .get<T>(`/ScoregBackend/public/${path}/${uuid}`)
        .then((r) => r.data)
        .catch((err) => {
            if (err.response.status === 403) {
                throw new NoPermissionError(path, uuid);
            }
            throw err
        })

    return detail
}

export function handleApiError(entity: string, identifier: string, err: { response: { status: number, data: { code: string, message: string, identifier: string } } }) {
    // console.log(err)
    if (err instanceof ApiResponseError) {
        return err;
    } else if (err.response?.status === 400) {
        return new ValidationError(entity, identifier, err.response.data.code, err.response.data.message);
    } else if (err.response?.status === 401) {
        return new NoSessionError();
    } else if (err.response?.status === 403) {
        return new NoPermissionError(err.response.data.message || entity, identifier, err.response.data.identifier);
    } else if (err.response?.status === 404) {
        return new NotFoundError(entity, identifier);
    } else if (err.response?.status === 409) {
        return new ConflictError(entity, identifier, err.response.data.code, err.response.data.message);
    } else if (err.response?.status === 500) {
        return new ServerSideError();
    } else if (err.response?.status === 503) {
        return new ServiceUnavailableError();
    }
    return err
}